
    import styled from "styled-components";

    const TemplatesLibraryPageStyled = styled.div``;

    export { TemplatesLibraryPageStyled };
    